export default function NotFound() {
  return (
    <div className="msg">
      <div className="msg__title">Page not found</div>
      <div className="msg__sub">The link you used isn't valid.</div>
    </div>
  );
}
